import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppColor from "utilities/AppColor";
import PropTypes from "prop-types";
import IconPlayStore from "assets/icons/play-store.svg";
import IconAppStore from "assets/icons/app-store.svg";

const styles = makeStyles(() => ({
  container: {
    padding: "0.4rem 0",
    display: 'flex',
    alignItems: 'center'
  },
  success: {
    fontSize: '7rem',
    color: AppColor.mainColor,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem',
    '& .title-success': {
      fontSize: '1rem',
      color: AppColor.black,
      marginTop: '2rem',
      fontWeight: 700
    },
    '& .message-success': {
      color: AppColor.black,
      fontSize: '0.8rem',
      marginTop: '0rem',
      textAlign: 'center'
    },
    '& .advice-success': {
      color: AppColor.pink,
      fontSize: '0.8rem',
      marginTop: '1rem',
      textAlign: 'center'
    }
  },
  iconStore: {
    height: 40,
    width: 'initial',
    margin: '0.5rem 0.25rem'
  }
}));

const OnboardSuccess = ({ isClient, isCompany }) => {
  const { t } = useTranslation();
  const classes = styles();

  return (
    <div className={classes.container}>
      <div className={classes.success} style={{width: isCompany ? '100%' : ''}}>
        <i className="far fa-check-circle"></i>
        <span className='title-success'>{t('text.submitSuccess')}</span>
        <span className='message-success'>{t('text.onboardSuccess')}</span>
        {
          isClient
            ? (
              <span className='advice-success'>{t('text.onboardAdviceClient')}</span>
            )
            : ( !isCompany && <React.Fragment>
              <span className='advice-success'>{t('text.onboardAdviceWorker')}</span>
              <Box display="flex" className="mt-2">
                <img
                  src={IconAppStore}
                  className={classes.iconStore}
                />
                <a href="https://play.google.com/store/apps/details?id=com.careaid.mobileapp"
                  style={{ display: "flex" }}>
                  <img
                    src={IconPlayStore}
                    className={classes.iconStore}
                  />
                </a>
              </Box>
            </React.Fragment>
            )
        }
      </div>
    </div >
  );
}

OnboardSuccess.propTypes = {
  isClient: PropTypes.bool,
  isCompany: PropTypes.bool
};

export default OnboardSuccess;
